import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

export interface EncounterFiltersState {
  practitioner: string;
  status: string[];
  "triage-type": string[];
  hasCharges?: boolean;
}

const initialState: EncounterFiltersState = {
  practitioner: "",
  status: [],
  "triage-type": [],
};

const slice = createSlice({
  name: "encounterFilters",
  initialState,
  reducers: {
    setEncounterFilters(
      state: EncounterFiltersState,
      action: PayloadAction<Partial<EncounterFiltersState>>,
    ): void {
      Object.assign(state, action.payload);
    },
    updateEncounterFilter(
      state: EncounterFiltersState,
      action: PayloadAction<{ key: string; value: any }>,
    ): void {
      const { key, value } = action.payload;
      (state as any)[key] = value;
    },
    resetEncounterFilters(state: EncounterFiltersState): void {
      Object.assign(state, initialState);
    },
  },
});

export const {
  setEncounterFilters,
  updateEncounterFilter,
  resetEncounterFilters,
} = slice.actions;
export const { reducer } = slice;

export default slice;
